import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Location } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, FormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { OrdersService } from '../../services/orders.service';
import { InventoryService } from '../../services/inventory.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { OmsService } from '../../services/oms.service';
import { DispatchService } from '../../services/dispatch.service';
import { MatAccordion } from '@angular/material/expansion';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

declare const google: any;

@Component({
	selector: 'app-dispatches-driver-run',
	templateUrl: './dispatches-driver-run.component.html',
	styleUrls: ['./dispatches-driver-run.component.scss']
})
export class DispatchesDriverRunComponent implements OnInit {
	@ViewChild(MatAccordion) accordion: MatAccordion;

	@ViewChild('orderdetails') orderdetailsref: ElementRef;

	CHAT_ROOM = 'OrderBoard';
	user: any = [];
	color = 'blue';

	config: any = [];
	token = '';
	dispatches: any = [];
	selectedorder: any = false;
	trucks: any = [];
	allpoints: any = [];
	map: any = false;
	zoomed = false;
	zoom = 11;
	pathlines: any = [];
	markers: any = false;
	zoomed_details_truck: any = false;
	seleccted_alt: any = false;
	transfertruck = new UntypedFormControl('')
	truck =  new UntypedFormControl('');
	alltrucks: any = false;
	disabled = false;

	//'transfertruck'
	map_animation: any = google.maps.Animation.DROP;
	constructor(private modalService: NgbModal, private dispatchService: DispatchService, public omsService: OmsService, public location: Location, public ordersService: OrdersService, private globalSearchService: GlobalSearchService, private route: ActivatedRoute, public router: Router, public formBuilder: UntypedFormBuilder, public inventoryService: InventoryService) {

		this.globalSearchService.user.subscribe((result) => {
			this.user = result;
		});

		this.token = this.globalSearchService.randomString(12, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
		this.omsService.setupSocketConnection(this.token);
		this.color = this.globalSearchService.getColor();

	}

	ngOnInit(): void {

		this.route.params.subscribe(params => {
			if(params['id']) {
				this.truck.setValue(params['id']);
				this.loadRun(params['id']);
				this.disabled = true;
			} else {
				this.loadRun('')
			}
		});

		this.dispatchService.getTrucks().subscribe((result:any) => {

			if(result.length == 1){
				this.truck.setValue(result[0].id);
				this.disabled = true;
				//this.truck.value = result[0].id;
				this.loadRun(result[0].id);
			}

			this.trucks = result;
			this.alltrucks = result;
		});

		this.omsService.subscribeToCards((err, data) => {
			switch (data.type) {
			case 'dispatch':
				this.loadData();
				break;
			}
		})


	}

	truckFilter(event: any) {
		this.trucks = this.globalSearchService.filterItem(this.alltrucks , event, 'truck_name');
	}

	loadRun(event: any) {

		this.dispatchService.getActiveRun(event).subscribe((results: any) => {
			this.dispatches = results.dispatched;
			this.allpoints = results.allpoints;
		});
	}

	cancel(dispatch: any) {
		this.dispatchService.cancelDispatch(dispatch).subscribe(results => {
			this.loadData();
			this.modalService.dismissAll();
		})
	}

	deliverRun(truck: any) {
		const proceed = confirm('Mark All As Delivered?');
		if(proceed) {
			this.dispatchService.deliverRun(truck).subscribe(results => {
				this.loadData();
				this.modalService.dismissAll();
			})
		}
	}

	clearRun(truck: any) {
		const proceed = confirm('Clear This Run?');
		if(proceed) {
			this.dispatchService.clearRun(truck).subscribe(results => {
				this.loadData();
				this.modalService.dismissAll();
			})
		}
	}

	dropAtHome(dispatch: any) {
		this.dispatchService.returnDispatch(dispatch).subscribe(results => {
			this.loadData();
			this.modalService.dismissAll();
		})
	}

	delivered(dispatch: any) {
		this.dispatchService.deliverDispatch(dispatch).subscribe(results => {
			this.loadData();
			this.modalService.dismissAll();
		})
	}

	altLocation() {
		if (this.transfertruck.value) {
			this.dispatchService.transferDispatch(this.selectedorder.did, this.transfertruck.value).subscribe(results => {
				this.loadData();
				this.modalService.dismissAll();
			})
		}
	}

	loadData() {
		this.dispatchService.getActiveRun(this.truck.value).subscribe((results: any) => {
			this.dispatches = results.dispatched;
			this.allpoints = results.allpoints;
		});
	}

	back(): void {
		this.location.back()
	}

	viewOrder(order: any) {
		this.selectedorder = order
		this.modalService.open(this.orderdetailsref, { ariaLabelledBy: 'modal-title', size: 'xl', animation: false }).result.then((result) => {}, (reason) => {
			this.selectedorder = false;
		});
	}

	removeLines() {
		let i = 0;
		for (i = 0; i < this.pathlines.length; i++) {
			this.pathlines[i].setMap(null); //or line[i].setVisible(false);
		}
		this.pathlines = [];
	}

	//, list: string
	drop(event: CdkDragDrop < string[] > , list: any) {

		if (event.previousContainer === event.container) {
			moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
		} else {
			this.zoomTo(list.truck)

			transferArrayItem(event.previousContainer.data,
				event.container.data,
				event.previousIndex,
				event.currentIndex);
		}

		this.submitMessage();

	}

	getRecalc(column) {
		this.dispatchService.getDispatchRecalc(column).subscribe((results: any) => {
			this.dispatches = results.dispatches;
			this.trucks = results.trucks;
			this.allpoints = results.allpoints;
			if (results.allpoints.length) {

				if (this.zoomed) {
					this.zoomTo(this.zoomed_details_truck)
				} else {
					this.drawMap(results.allpoints, results.trucks)
				}
			}
		});
	}

	submitMessage() {

		//data has been re-arranged already by cdk drop
		//remove points from dispatches

		const thesedispatches = Object.create(this.dispatches);
		thesedispatches.forEach((d, index) => {

			thesedispatches[index] = d;
			thesedispatches[index].dispatched = d.dispatched.filter(a => { return a.ispoint == '0' });;
		})

		const data = { data: thesedispatches, user: this.user };

		if (data) {
			this.omsService.sendDispatchPositionUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
		}
	}

	identify(index, item) {
		return item.truck;
	}

	zoomToPoint(point: any) {

		const lat = !Number.isNaN(point.clat) ? point.clat : 0;
		const lng = !Number.isNaN(point.clng)? point.clng : 0;;
		const ltlng = new google.maps.LatLng(lat, lng);

		this.map.setZoom(12);
		this.map.setCenter(ltlng);
	}

	resetZoom() {
		this.map = false;
		this.drawMap(this.allpoints, this.trucks)
	}

	zoomTo(truckid: any) {
		this.zoom = 13;
		this.zoomed = true;
		this.zoomed_details_truck = truckid;
		this.map_animation = null;

		const dispatches = this.dispatches.filter(d => {
			return d.truck == truckid;
		})[0].allpoints;

		const truck = this.trucks.filter(d => {
			return d.id == truckid;
		});


		this.drawMap(dispatches, truck)
		const ltlng = new google.maps.LatLng(truck.lat, truck.lng);
		this.map.setCenter(ltlng);
	}

	drawMap(points: any, trucks: any) {

		this.markers = [];
		this.removeLines();
		//todo make this part of company settings
		const home = { lat: 42.928455044944165, lng: -78.82142723259965 }
		const lines = [home];
		const columndata = points;
		let shortlines = [];
		const colors = [];

		if (this.map) {
			while (this.markers.length) { this.markers.pop().setMap(null); }
			this.map_animation = null;
		}

		trucks.forEach((item: any) => {

			const ltlng = new google.maps.LatLng(item.lat, item.lng);

			const m = new google.maps.Marker({
				icon: 'assets/img/truckicon.png',
				size: '100,100',
				position: ltlng,
				title: item.name,
				optimized: true,
				//icon: svgMarker,
				animation: this.map_animation,
				//fillColor: item.color,
				//strokeColor: item.color,
				label: {
					text: item.name,
					color: '#000',
					fontSize: '14px',
					fontWeight: 'bold',
				}
			});

			this.markers.push(m);
		});
		shortlines = [];
		let i = 0;
		columndata.forEach((item: any) => {
			//lines.push({lat: parseFloat(item.lat), lng: parseFloat(item.lng)})
			if (!shortlines[item.truck.id]) {
				shortlines[item.truck.id] = [];
			}

			if (!colors[item.truck.id]) {
				colors[item.truck.id] = [];
			}

			shortlines[item.truck.id].push({ lat: parseFloat(item.lat), lng: parseFloat(item.lng) });
			colors[item.truck.id].push(item.color);

			const ltlng = new google.maps.LatLng(item.lat, item.lng);
			const itemsort = +item.sort;

			const pinColor = item.color;

			//#00c853

			const pinSVGHole = 'M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z';
			const labelOriginHole = new google.maps.Point(12, 15);
			const pinSVGFilled = 'M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z';

			const labelOriginFilled = new google.maps.Point(12, 9);

			const markerImage = { // https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerLabel
				path: pinSVGFilled,
				anchor: new google.maps.Point(12, 17),
				fillOpacity: 1,
				fillColor: pinColor,
				strokeWeight: 1,
				strokeColor: 'white',
				scale: 1,
				labelOrigin: labelOriginFilled
			};
			let label = item.itemsort;
			if (item.itemsort == '-1' || item.itemsort == '9999999') {
				label = 'ORIGIN';
			}

			const m = new google.maps.Marker({
				icon: markerImage,
				position: ltlng,
				title: '(' + label + ') ' + item.invoice,
				optimized: true,
				//icon: svgMarker,
				animation: this.map_animation,
				//fillColor: item.color,
				//strokeColor: item.color,
				label: {
					text: '(' + label + ')',
					color: '#fff',
					fontSize: '14px',
					fontWeight: 'bold',
				}
			});
			i++;
			this.markers.push(m);
		});


		//lines.push(home);
		//this.markers.push(home);

		const myLatlng = new google.maps.LatLng(42.928455044944165, -78.82142723259965);
		const mapOptions = {
			zoom: this.zoom,
			center: myLatlng,
			scrollwheel: false, //we disable de scroll over the map, it is a really annoing when you scroll through page
			styles: [{
				'featureType': 'water',
				'stylers': [{
					'saturation': 43
				}, {
					'lightness': -11
				}, {
					'hue': '#0088ff'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'geometry.fill',
				'stylers': [{
					'hue': '#ff0000'
				}, {
					'saturation': -100
				}, {
					'lightness': 99
				}]
			}, {
				'featureType': 'road',
				'elementType': 'geometry.stroke',
				'stylers': [{
					'color': '#808080'
				}, {
					'lightness': 54
				}]
			}, {
				'featureType': 'landscape.man_made',
				'elementType': 'geometry.fill',
				'stylers': [{
					'color': '#ece2d9'
				}]
			}, {
				'featureType': 'poi.park',
				'elementType': 'geometry.fill',
				'stylers': [{
					'color': '#ccdca1'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'labels.text.fill',
				'stylers': [{
					'color': '#767676'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'labels.text.stroke',
				'stylers': [{
					'color': '#ffffff'
				}]
			}, {
				'featureType': 'poi',
				'stylers': [{
					'visibility': 'off'
				}]
			}, {
				'featureType': 'landscape.natural',
				'elementType': 'geometry.fill',
				'stylers': [{
					'visibility': 'on'
				}, {
					'color': '#b8cb93'
				}]
			}, {
				'featureType': 'poi.park',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.sports_complex',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.medical',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.business',
				'stylers': [{
					'visibility': 'simplified'
				}]
			}]

		};


		if (!this.map) {
			this.map = new google.maps.Map(document.getElementById('map'), mapOptions);
		}

		const marker = new google.maps.Marker({
			position: myLatlng,
			title: 'Home'
		});

		marker.setMap(this.map);

		this.markers.forEach((item: any) => {
			item.setMap(this.map);
		});

		const lineSymbol = {
			path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
		};

		shortlines.forEach((line, index) => {
			const lines = new google.maps.Polyline({
				path: line,
				geodesic: true,
				strokeColor: colors[index][0],
				strokeOpacity: 1.0,
				strokeWeight: 2,
				icons: [{
					icon: lineSymbol,
					offset: '100%'
				}],
			});

			this.pathlines.push(lines)
			//lines.setMap(this.map);
		})

		for (i = 0; i < this.pathlines.length; i++) {
			this.pathlines[i].setMap(this.map);
		}


		// To add the marker to the map, call setMap();

	}

}
